import React, { useEffect } from 'react';
import { SESSION_ID_COOKIE } from '../utils/useSegment';
import useCookie from '../utils/useCookie';

// Source: https://www.codegrepper.com/code-examples/javascript/javascript+generate+uuid+v4
function generateRandomHashcode() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const randomHash = (Math.random() * 16) | 0; // eslint-disable-line
    const v = c === 'x' ? randomHash : (randomHash & 0x3) | 0x8; // eslint-disable-line
    return v.toString(16);
  });
}

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * */
export default function SessionIdWrapper(props) {
  const [sessionIdCookie, setSessionIdCookie] = useCookie(SESSION_ID_COOKIE);

  useEffect(() => {
    if (!sessionIdCookie) {
      setSessionIdCookie(generateRandomHashcode(), 0.5);
    } else {
      // If exists, re-sets cookie expire date
      setSessionIdCookie(sessionIdCookie, 0.5);
    }
  }, []);

  return <>{props.children}</>;
}
